const hasPropertyAttempts = [
    (object, key) => {
        return key in object;
    },
    (object, key) => {
        /** This handles cases where the input object can't use `in` directly, like string literals */
        return key in object.constructor.prototype;
    },
];
export function typedHasProperty(inputObject, inputKey) {
    if (!inputObject) {
        return false;
    }
    return hasPropertyAttempts.some((attemptCallback) => {
        try {
            return attemptCallback(inputObject, inputKey);
        }
        catch (error) {
            return false;
        }
    });
}
export function typedHasProperties(inputObject, inputKeys) {
    return inputObject && inputKeys.every((key) => typedHasProperty(inputObject, key));
}
